import { render } from "./ConfigureSubscriptionForm.vue?vue&type=template&id=202b8afb&scoped=true"
import script from "./ConfigureSubscriptionForm.vue?vue&type=script&lang=js"
export * from "./ConfigureSubscriptionForm.vue?vue&type=script&lang=js"

import "./ConfigureSubscriptionForm.vue?vue&type=style&index=0&id=202b8afb&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202b8afb"]])

export default __exports__